<template>
<div id="statslist" class="right-content">
  <el-form :model="filters" class="head-form">
    <el-row type="flex" justify="center" :gutter="20">

      <el-col :xs="6" :sm="6" :md="6" :lg="4">
        <el-form-item prop="state">
          <el-select v-model="filters.state" clearable placeholder="全部" @change="handleStateChange">
            <el-option
              v-for="item in formatState"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :xs="5" :sm="5" :md="6" :lg="4">
        <el-form-item prop="category">
         <el-date-picker
                v-model="filters.fsdate"
                align="right"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions1"
                @change="handleDateChange">
              </el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :xs="8" :sm="8" :md="7" :lg="4">
        <el-form-item prop="searchterm">
          <el-input placeholder="请输入关键词"
            icon="circle-cross"
            v-model="filters.searchterm"
            :on-icon-click="handleClearClick" >
          </el-input>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="1">&nbsp;&nbsp;</el-col> -->
      <el-col :xs="3" :sm="3" :md="3" :lg="2">
        <el-form-item prop="searchbutton">
          <el-button icon="search" @click="handleSearchClick">搜索</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>


  <emptyCont :show="!getStatsDataLen"></emptyCont>
  <contentList :newsdata='formatNewsData' :goUrl='goEdit' :limit='limit' :total='statstotal' :handlePageChange='handlePageChange' :urladdr='linkpath'> </contentList>

  <!--分页-->
  <div class="nav-pagin">
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="22" :lg="14" class="el-item shadow">
        <el-pagination layout="total, prev, pager, next, jumper" :current-page.sync="page" @current-change="handlePageChange" :page-size="limit" :total="statstotal">
        </el-pagination>
      </el-col>
    </el-row>
  </div>


</div>
</template>

<script type="text/javascript">
/**
 * 销售数据概览页组件
 */
import {mapGetters, mapActions} from 'vuex';
import { getNowTime, routeMap } from '../../utils/com.js'
import '../../static/style/stats/list.scss'
import { newsType, hotsType, newsPlatform, auditFullType } from '../../config/config'
import { cloneObj } from '../../utils/com.js'
import { Loading } from 'element-ui';
import emptyCont from '../common/emptycontent.vue'
import contentList from '../common/contentlist.vue'

export default {
    data() {
        return {
            pickerOptions1: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              },
              shortcuts: [{
                text: '今天',
                onClick(picker) {
                  picker.$emit('pick', new Date());
                }
              }, {
                text: '昨天',
                onClick(picker) {
                  const date = new Date();
                  date.setTime(date.getTime() - 3600 * 1000 * 24);
                  picker.$emit('pick', date);
                }
              }, {
                text: '一周前',
                onClick(picker) {
                  const date = new Date();
                  date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', date);
                }
              }]
            },
            filters: {
                fsdate: '',
                searchterm: '',
                state: '',
            },
            newloading: false,
            show: true,
            currentDate: new Date(),
            date: getNowTime(),
            page: 1,
            limit: 10,
            clientid: 1,
            linkpath: './review',
            // date: new Date().format("yyyy-MM-dd")
        }
    },
    created() {
        // let param = {
        //     date: this.filters.fsdate,
        //     keyword: this.filters.searchterm,
        //     state: this.filters.state,
        //     page: this.page,
        //     limit: this.limit,
        // }
        // console.debug("created> getConsoleNews> param:%o", param);

        // this.updateLoadingStatus(true);
        // this.getConsoleNews(param).then(
        //   (resp) => {
        //     this.updateLoadingStatus(false);
        //     console.debug("created> getConsoleNews> resp:%o", resp);
        //     if(resp && resp.code !== 0){
        //       that.$message({
        //             message: resp.msg,
        //             type: 'error'
        //         });
        //     }
        //   }
        // );
        // this.page = 1;
        // this.filters.fsdate = '';
        // this.filters.searchterm = '';
        // this.filters.state = '';
        let curpage = this.$route.query.page || 1;
        this.page = parseInt(curpage);
        this.filters.fsdate = this.$route.query.fsdate || '';
        this.filters.searchterm = this.$route.query.searchterm || '';
        this.filters.state = this.$route.query.state || '';
        this.reqConsoleNewsData();
        console.debug("list> created> linkpath:%o", this.linkpath);
    },
    watch: {
        '$route' (to, from){
            console.debug("watch>route start to:%o, from:%o", to, from);
            console.debug("watch>route category:%o, page:%o", this.$route.query.category, this.transitionName, this.$route.query.page);
            let curpage = this.$route.query.page || 1;
            this.page = parseInt(curpage);
            this.filters.fsdate = this.$route.query.fsdate || '';
            this.filters.searchterm = this.$route.query.searchterm || '';
            this.filters.state = this.$route.query.state || '';
            this.reqConsoleNewsData();
        }
    },
    computed: {
        ...mapGetters({
            // 映射 this.statsdata 为 store.getters.statsdata
            statsdata: 'statsdata',
            statstotal: 'statstotal',
            getAccesstoken: 'getAccesstoken',
            getAppid: 'getAppid',
            getRole: 'getRole',
        }),
        getStatsDataLen: function() {
            console.debug("getStatsDataLen> statsdata.length:%o", this.statsdata.length);
            return this.statsdata.length;
        },
        formatCategory(){
          let typelists = [];
          for(let i in newsType){
            let typelist = {}
            typelist.value = i;
            typelist.label = newsType[i];
            typelists.push(typelist);
          }
          console.debug("formatCategory> typelists:%o", typelists);
          return typelists;
        },
        formatState(){
          let statelists = [];
          for(let i in auditFullType){
            let statelist = {}
            statelist.value = i;
            statelist.label = auditFullType[i];
            statelists.push(statelist);
          }
          console.debug("formatState> statelists:%o", statelists);
          return statelists;
        },
        formatNewsData: function () {
              // `this` points to the vm instance
              let lists = [];
              // console.debug("formatNewsData> statsdata:%o", this.statsdata);
              for(let i in this.statsdata){
                let l = {};
                let newdata = this.statsdata[i];
                // console.debug("formatNewsData> newdata:%o", newdata);
                // l.id = newdata.id || 0;
                // l.mediaurl = newdata.mediaurl || '';
                // l.mediaduration = newdata.mediaduration || 0;
                // l.mediasize = newdata.mediasize || 0;
                // l.state = newdata.state || 0;
                // l.tip = newdata.tip || '';
                // l.title = newdata.title || '';
                // l.content = newdata.content || '';
                // let hi = newdata.hotindex+'' || '7';
                // l.hotindex =hotsType[hi];
                // l.cover = newdata.cover || '';
                // let sf = newdata.sourcefrom || '';
                // l.sourcefrom = newsPlatform[sf];

                // l.sourceurl = newdata.sourceurl || '';
                // l.date = newdata.date || '';
                // l.editor = newdata.editor || '';
                // l.host = newdata.host || '';
                // l.verifier = newdata.verifier || '';

                // let cat = newdata.category || '1';
                // l.category = newsType[cat];
                // let ls = newdata.labels || '#';
                // l.labels = ls.split('#');

                l = cloneObj(newdata);
                let hi = newdata.hotindex+'' || '7';
                l.hotindex =hotsType[hi];
                // let sf = newdata.sourcefrom || '';
                // l.sourcefrom = newsPlatform[sf];
                let cat = newdata.category || '1';
                l.category = newsType[cat];
                let ls = newdata.labels || '#';
                l.labels = ls.split('#');
                let ss = newdata.state || '1';
                l.state = auditFullType[ss];
                // console.debug("formatMarkers> newsData:%o, ls:%o", newdata, ls);
                lists.push(l);
              }
              console.debug("formatMarkers> lists:%o", lists);
              return lists;
            }
    },
    methods: {
        ...mapActions({
          // 映射 this.getEditorData() 为 this.$store.dispatch('getEditorData')
          getConsoleNews: 'getConsoleNews',
          updateLoadingStatus: 'updateLoadingStatus',
          getNewStatis: 'getNewStatis',
          getConsoleEvent: 'getConsoleEvent',
          updateNewsContent: 'updateNewsContent',
        }),
        reqConsoleNewsData(){
          var that = this;
          let param = {
              date: that.filters.fsdate || new Date().format('yyyy-MM-dd'),
              keyword: that.filters.searchterm,
              state: that.filters.state,
              page: that.page,
              limit: that.limit,
          }
          console.debug("reqConsoleNewsData> param:%o", param);
          that.updateLoadingStatus(true);
          that.getConsoleNews(param).then(
            (resp) => {
              that.updateLoadingStatus(false);
              console.debug("reqConsoleNewsData> resp:%o", resp);
              if(resp && resp.code !== 0){
                that.$message({
                      message: resp.msg,
                      type: 'error'
                  });
              }
            }
          );
        },
        handleClearClick(ev){
          console.debug("handleClearClick> ev:%o", ev);
          var that = this;
          this.filters.searchterm = '';
          this.filters.fsdate = '';
          this.page = '1';

          // this.reqConsoleNewsData();
          // let param = {
          //     date: this.filters.fsdate,
          //     keyword: this.filters.searchterm,
          //     page: this.page,
          //     limit: this.limit,
          // }
          // console.debug("created> getConsoleNews> param:%o", param);

          // this.updateLoadingStatus(true);
          // this.getConsoleNews(param).then(
          //   (resp) => {
          //     this.updateLoadingStatus(false);
          //     console.debug("created> getConsoleNews> resp:%o", resp);
          //     if(resp && resp.code !== 0){
          //       that.$message({
          //             message: resp.msg,
          //             type: 'error'
          //         });
          //     }
          //   }
          // );

          this.$router.push({ path: routeMap('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state} });
        },
        handleSearchClick(ev) {
          // console.debug("handleSearchClick> ev:%o, searchtype:%o", ev, this.filters.searchtype);
          // var that = this;
          // this.reqConsoleNewsData();
          // let param = {
          //     date: this.filters.fsdate,
          //     keyword: this.filters.searchterm,
          //     state: this.filters.state,
          //     page: this.page,
          //     limit: this.limit,
          // }
          // console.debug("created> getConsoleNews> param:%o", param);

          // this.updateLoadingStatus(true);
          // this.getConsoleNews(param).then(
          //   (resp) => {
          //     this.updateLoadingStatus(false);
          //     console.debug("created> getConsoleNews> resp:%o", resp);
          //     if(resp && resp.code !== 0){
          //       that.$message({
          //             message: resp.msg,
          //             type: 'error'
          //         });
          //     }
          //   }
          // );
          this.filters.searchterm = (typeof(this.filters.searchterm) === 'string') ? this.filters.searchterm.replace(/(^\s*)|(\s*$)/g, "") : '';
          this.$router.push({ path: routeMap('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state} });
        },
        handleDateChange(val) {
          console.debug("handleDateChange> val:%o, fsdate:%o", val, this.filters.fsdate);
          if(this.filters.fsdate !== val){
            this.filters.fsdate = val;
            // this.reqConsoleNewsData();
            // let param = {
            //     date: this.filters.fsdate,
            //     keyword: this.filters.searchterm,
            //     state: this.filters.state,
            //     page: this.page,
            //     limit: this.limit,
            // }
            // console.debug("created> getConsoleNews> param:%o", param);
            // // this.getEditorData(param);

            // this.updateLoadingStatus(true);
            // this.getConsoleNews(param).then(
            //   (resp) => {
            //     this.updateLoadingStatus(false);
            //     console.debug("created> getConsoleNews> resp:%o", resp);
            //     if(resp && resp.code !== 0){
            //       that.$message({
            //             message: resp.msg,
            //             type: 'error'
            //         });
            //     }
            //   }
            // );
          }
          this.$router.push({ path: routeMap('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state} });
        },
        handleStateChange(val) {
          console.debug("handleStateChange> val:%o, state:%o", val, this.filters.state);
          // this.reqConsoleNewsData();
          this.$router.push({ path: routeMap('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state} });
        },
        handlePageChange(val) {
          console.debug("handlePageChange> val:%o", val);
          if(this.page !== val){
            this.page = val;
            // this.reqConsoleNewsData();
            // let param = {
            //     date: this.filters.fsdate,
            //     keyword: this.filters.searchterm,
            //     state: this.filters.state,
            //     page: this.page,
            //     limit: this.limit,
            // }
            // console.debug("created> getConsoleNews> param:%o", param);
            // // this.getEditorData(param);

            // this.updateLoadingStatus(true);
            // this.getConsoleNews(param).then(
            //   (resp) => {
            //     this.updateLoadingStatus(false);
            //     console.debug("created> getConsoleNews> resp:%o", resp);
            //     if(resp && resp.code !== 0){
            //       that.$message({
            //             message: resp.msg,
            //             type: 'error'
            //         });
            //     }
            //   }
            // );

          }
          this.$router.push({ path: routeMap('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state} });

        },
        goEdit(item){

            if(!item){
                return false;
            }
            item.labels = item.labels.join('#');
            for(let i in newsType){
                if(newsType[i] === item.category){
                    item.category = i;
                    break;
                }
            }
            // for(let i in newsPlatform){
            //     if(newsPlatform[i] === item.sourcefrom){
            //         item.sourcefrom = i;
            //         break;
            //     }
            // }
            item.hotindex = item.hotindex+'';
            console.debug("goto> item:%o", item);
            // this.updateNewsContent(item);
            this.$router.push({ path: './review',query: { id:item.id }})
            // this.$router.push({ path: './edit',query: { id:index }})
            //this.$router.push('./edit');
        }
    },
    components: {
      emptyCont,
      contentList
    }
}
</script>



// WEBPACK FOOTER //
// list.vue?272d4121